module.exports = __webpack_public_path__ + "img/circle.842262bf.png";